import type { Components, Theme } from "@mui/material";

export const MuiCheckbox: Components<Theme>["MuiCheckbox"] = {
  defaultProps: {
    color: "orange"
  }
};
